export default __webpack_public_path__ + "static/designer-andrei-f1e211fe830abeea9334d2270ec35219.png";